import { Outlet } from "@remix-run/react";

export const handle = {
  breadcrumb: () => {
    return "Blog";
  },
};

// Just a wrapper to make breadcrumbs work properly
export default function BlogLayout() {
  return (
    <div>
      <Outlet />
    </div>
  );
}
